import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material";
import { IHolding } from "src/app/interfaces/holding";
import { Component, OnInit, Inject } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ContractService } from "src/app/services/http/business/contract/contract.service";
import { HidService } from "src/app/services/common/hid.service";
import { CIDService } from "src/app/services/common/cid.service";
import { BIDService } from "src/app/services/common/bid.service";
import { Router } from "@angular/router";
import { TimesheetManagementComponent } from "../timesheet-management/timesheet-management.component";

@Component({
  selector: "app-choose-holding-and-company",
  templateUrl: "./choose-holding-and-company.component.html",
  styleUrls: ["./choose-holding-and-company.component.css"]
})
export class ChooseHoldingAndCompanyComponent implements OnInit {
  form: FormGroup;
  branchList: any;
  cid: string;
  bid: string;
  bName: string;
  isTeacherContractSelected = false;
  brancSelectedName: any;
  roleSelectedName: any;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private cidService: CIDService,
    private bidService: BIDService,
    private hidService: HidService,
    private contractService: ContractService,
    public dialogRef: MatDialogRef<ChooseHoldingAndCompanyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IHolding
  ) { }

  ngOnInit() {
    this.createForm();
    this.getBranchThatUserHasContract();
    this.hidService.setHID(this.data.HoldingEncryptCode);
  }

  createForm() {
    this.form = this.fb.group({
      branchId: [null, Validators.compose([Validators.required])]
    });
  }
  getBranchThatUserHasContract() {
    this.contractService.GetBranchThatUserHasContract().subscribe(res => {
      this.branchList = res;
    });
  }

  fillLocalStorage(e: any) {
    var branchSelected = e
    debugger;
    this.brancSelectedName = branchSelected.BranchName;
    this.roleSelectedName = branchSelected.RoleTitle;
    this.cid = e.CompanyEncryptId;
    this.bid = e.BranchEncryptId;
    this.bName = e.BranchName;
    let contractTypeId = e.ContractTypeId;
    if (contractTypeId === 121 || contractTypeId === 123 || contractTypeId === 124)
      this.isTeacherContractSelected = true;
    else
      this.isTeacherContractSelected = false;
  }

  submit(_data: any) {
    this.closeModal();
    this.cidService.setCID(this.cid);
    this.bidService.setBID(this.bid, this.bName);
    this.cidService.setBrnachRoleName(this.brancSelectedName, this.roleSelectedName);
    this.router.navigate(["management"]);
  }

  showTimeSheetForm(_data: any) {
    debugger
    this.dialog.open(TimesheetManagementComponent, {
      width: "95%",
      data: {
        isAsset: true,
        cid: this.cid,
        bid: this.bid,
        branchName: this.bName
      }
    });
  }

  closeModal() {
    this.dialogRef.close();
  }
}
